import { render, staticRenderFns } from "./salesperson_invoice.vue?vue&type=template&id=62c27fff&scoped=true&"
import script from "./salesperson_invoice.vue?vue&type=script&lang=js&"
export * from "./salesperson_invoice.vue?vue&type=script&lang=js&"
import style0 from "./salesperson_invoice.vue?vue&type=style&index=0&id=62c27fff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c27fff",
  null
  
)

export default component.exports